export const LEARNING_PROGRESS_ADVANCED_FILTERS_STORAGE_KEY = "learning_progress_advanced_filters";
